import { Button, Form, Input, Tag, Space } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { context } from "../../context/context";
import ModalTags from "../GeoUnit/ModalTags";
import { http } from "../../services/httpService";
import config from "../../services/config.json";

const DiscountForm = () => {
    const [form] = Form.useForm();
    // state
    const [isEditSelected, setIsEditSelected] = useState(false);
    const [inputTitleStyle, setInputTitleStyle] = useState({
        width: "100%",
        outline: "0",
    });
    const [inputDescriptionStyle, setDescriptionInputStyle] = useState({
        width: "100%",
        outline: "0",
    });
    //context
    const {
        discountLinks,
        setDiscountLinks,
        discountLinkTitle,
        discountLinkUrl,
        setDiscountLinkTitle,
        setDiscountLinkUrl,
        setDiscountTitle,
        setDiscountDescription,
        selectedDiscountId,
        setDiscountTags,
        setDiscountCover,
        setDiscountMedia,
        discountTitle,
        discountDescription,
    } = useContext(context);
    useEffect(() => {
        if (selectedDiscountId) {
            http.get(
                `${config.parkopoloApi}/api/Discount/${selectedDiscountId}`
            )
                .then((res) => {
                    setDiscountLinks(res.data.result.links);
                    setDiscountTitle(res.data.result.title);
                    setDiscountDescription(res.data.result.description);
                    setDiscountTags(res.data.result.tags);
                    setDiscountCover([res.data.result.coverPic]);
                    setDiscountMedia(res.data.result.media);
                })
                .catch((err) => {
                    console.log(err);
                });
            setIsEditSelected(true);
        }
    }, []);
    //finction
    const handleDeleteLink = (url) => {
        const links = discountLinks.filter((link) => link.url !== url);
        setDiscountLinks(links);
        setDiscountLinkTitle("");
        setDiscountLinkUrl("");
    };
    const handleDeleteAction = () => {
        setDiscountLinkTitle("");
        setDiscountLinkUrl("");
    };
    const handleTitleChange = (e) => {
        setDiscountTitle(e.target.value);
    };
    const handleDescriptionChange = (e) => {
        setDiscountDescription(e.target.value);
    };
    const onUrlChange = (e) => {
        setDiscountLinkUrl(e.target.value);
    };
    const onTitleChange = (e) => {
        setDiscountLinkTitle(e.target.value);
    };
    const handleAddLink = () => {
        const newLink = {
            url: discountLinkUrl,
            title: discountLinkTitle,
            kind: "web",
        };
        setDiscountLinkTitle("");
        setDiscountLinkUrl("");
        setDiscountLinks((discountLinks) => [...discountLinks, newLink]);
    };

    return (
        <div
            style={{
                direction: "rtl",
                display: "flex",
                gap: "15px",
                margin: "15px",
            }}
        >
            <Form
                layout="vertical"
                form={form}
                name="control-hooks"
                style={{
                    width: "100%",
                }}
            >
                <div style={{ display: "flex", gap: "2rem" }}>
                    <Form.Item
                        name="عنوان"
                        label="عنوان"
                        style={{ width: "100%" }}
                    >
                        <h4 style={{ textAlign: "right", display: "none" }}>
                            {discountTitle}
                        </h4>
                        <input
                            style={inputTitleStyle}
                            className="ant-input css-dev-only-do-not-override-lzp0br css-dev-only-do-not-override-lzp0br"
                            type="text"
                            value={isEditSelected ? discountTitle : null}
                            onChange={handleTitleChange}
                            placeholder="عنوان را وارد کنید"
                            onFocus={() => {
                                const updatedStyle = {
                                    ...inputTitleStyle,
                                    outline: "1px solid #48D1CC",
                                    borderColor: "#48D1CC",
                                };
                                setInputTitleStyle(updatedStyle);
                            }}
                            onBlur={() => {
                                const updatedStyle = {
                                    ...inputTitleStyle,
                                    outline: "",
                                    borderColor: "",
                                };
                                setInputTitleStyle(updatedStyle);
                            }}
                            onMouseEnter={() => {
                                const updatedStyle = {
                                    ...inputTitleStyle,
                                    borderColor: "#48D1CC",
                                };
                                setInputTitleStyle(updatedStyle);
                            }}
                            onMouseLeave={() => {
                                const updatedStyle = {
                                    ...inputTitleStyle,
                                    borderColor: "",
                                };
                                setInputTitleStyle(updatedStyle);
                            }}
                        />
                    </Form.Item>
                </div>
                <div style={{ display: "flex", gap: "2rem" }}>
                    <Form.Item
                        name="توضیحات"
                        label="توضیحات"
                        style={{ width: "100%" }}
                    >
                        <h4 style={{ textAlign: "right", display: "none" }}>
                            در حال ویرایش {discountTitle}
                        </h4>
                        <input
                            style={inputDescriptionStyle}
                            className="ant-input css-dev-only-do-not-override-lzp0br css-dev-only-do-not-override-lzp0br"
                            type="text"
                            value={isEditSelected ? discountDescription : null}
                            onChange={handleDescriptionChange}
                            placeholder="توضیحات را وارد کنید"
                            onFocus={() => {
                                const updatedStyle = {
                                    ...inputDescriptionStyle,
                                    outline: "1px solid #48D1CC",
                                    borderColor: "#48D1CC",
                                };
                                setDescriptionInputStyle(updatedStyle);
                            }}
                            onBlur={() => {
                                const updatedStyle = {
                                    ...inputDescriptionStyle,
                                    outline: "",
                                    borderColor: "",
                                };
                                setDescriptionInputStyle(updatedStyle);
                            }}
                            onMouseEnter={() => {
                                const updatedStyle = {
                                    ...inputDescriptionStyle,
                                    borderColor: "#48D1CC",
                                };
                                setDescriptionInputStyle(updatedStyle);
                            }}
                            onMouseLeave={() => {
                                const updatedStyle = {
                                    ...inputDescriptionStyle,
                                    borderColor: "",
                                };
                                setDescriptionInputStyle(updatedStyle);
                            }}
                        />
                    </Form.Item>
                </div>
                <div
                    style={{
                        display: "flex",
                        gap: "30px",
                        alignItems: "center",
                    }}
                >
                    <Form.Item
                        name="آدرس لینک"
                        label="آدرس لینک"
                        style={{ width: "100%" }}
                    >
                        <h6 style={{ display: "none" }}>{discountLinkUrl}</h6>
                        <Input
                            value={discountLinkUrl}
                            onChange={onUrlChange}
                            placeholder="آدرس لینک را وارد کنید"
                        />
                    </Form.Item>
                    <Form.Item
                        name="عنوان لینک"
                        label="عنوان لینک"
                        style={{ width: "100%" }}
                    >
                        <h6 style={{ display: "none" }}>{discountLinkTitle}</h6>

                        <Input
                            value={discountLinkTitle}
                            onChange={onTitleChange}
                            placeholder="عنوان لینک را وارد کنید"
                        />
                    </Form.Item>
                    <Button
                        onClick={handleAddLink}
                        disabled={
                            !discountLinkTitle ||
                            discountLinkTitle === "" ||
                            !discountLinks ||
                            discountLinkUrl.slice(0, 8) !== "https://"
                        }
                    >
                        اضافه کردن لینک جدید
                    </Button>
                </div>
                <Space wrap>
                    {discountLinks.map((link) => {
                        return (
                            <Tag
                                color="blue"
                                closeIcon
                                key={link.url}
                                onClose={() => handleDeleteLink(link.url)}
                                onClick={handleDeleteAction}
                            >
                                {link.url}{" "}
                            </Tag>
                        );
                    })}
                </Space>

                <Form.Item name="تگ" label="تگ ها">
                    <div>
                        {" "}
                        <ModalTags section="discount" />
                    </div>
                </Form.Item>
            </Form>
        </div>
    );
};

export default DiscountForm;
